var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOmr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "omr",
    transform: "translate(2892 -5635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    transform: "translate(-2892 5635)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658",
    transform: "translate(-17 -281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "print",
    transform: "translate(-2866 5931)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 75.318,
    height: 39.264,
    transform: "translate(0 24.376)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 46.27,
    height: 31.018,
    transform: "translate(14.523 11.677)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 23.136,
    height: 31.018,
    transform: "translate(37.659 11.677)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 38.682,
    height: 38.463,
    transform: "translate(18.319 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 2.7,
    cy: 2.7,
    r: 2.7,
    transform: "translate(4.853 53.935)",
    fill: "#ffdc00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 2.7,
    cy: 2.7,
    r: 2.7,
    transform: "translate(13.83 53.935)",
    fill: "#35ccff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 1.829,
    cy: 1.829,
    r: 1.829,
    transform: "translate(23.199 4.926)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 1.829,
    cy: 1.829,
    r: 1.829,
    transform: "translate(23.199 10.837)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 1.829,
    cy: 1.829,
    r: 1.829,
    transform: "translate(23.199 16.749)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 1.829,
    cy: 1.829,
    r: 1.829,
    transform: "translate(29.111 4.926)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73-2",
    "data-name": "Ellipse 73",
    cx: 1.829,
    cy: 1.829,
    r: 1.829,
    transform: "translate(36.336 4.926)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73-3",
    "data-name": "Ellipse 73",
    cx: 1.829,
    cy: 1.829,
    r: 1.829,
    transform: "translate(43.561 4.926)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73-4",
    "data-name": "Ellipse 73",
    cx: 1.829,
    cy: 1.829,
    r: 1.829,
    transform: "translate(50.787 4.926)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73-5",
    "data-name": "Ellipse 73",
    cx: 1.829,
    cy: 1.829,
    r: 1.829,
    transform: "translate(29.111 10.837)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73-6",
    "data-name": "Ellipse 73",
    cx: 1.829,
    cy: 1.829,
    r: 1.829,
    transform: "translate(36.336 10.837)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73-7",
    "data-name": "Ellipse 73",
    cx: 1.829,
    cy: 1.829,
    r: 1.829,
    transform: "translate(43.561 10.837)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73-8",
    "data-name": "Ellipse 73",
    cx: 1.829,
    cy: 1.829,
    r: 1.829,
    transform: "translate(50.787 10.837)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73-9",
    "data-name": "Ellipse 73",
    cx: 1.829,
    cy: 1.829,
    r: 1.829,
    transform: "translate(29.111 16.749)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73-10",
    "data-name": "Ellipse 73",
    cx: 1.829,
    cy: 1.829,
    r: 1.829,
    transform: "translate(36.336 16.749)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73-11",
    "data-name": "Ellipse 73",
    cx: 1.829,
    cy: 1.829,
    r: 1.829,
    transform: "translate(43.561 16.749)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73-12",
    "data-name": "Ellipse 73",
    cx: 1.829,
    cy: 1.829,
    r: 1.829,
    transform: "translate(50.787 16.749)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmr);
export default __webpack_public_path__ + "static/media/omr.9358a0f8ab1d0ad495a892f2effad5d5.svg";
export { ForwardRef as ReactComponent };